import { isEqual } from './javascript'
export const LOGOUT = 'LOGOUT'

const userWiseRole = {
  admin: 1,
  consumer: 2, // Owner
  consumerUser: 3,
  dealer: 4, // Dealer
  dealerUser: 5,
  recycler: 6, // Scrapping Facility
  recyclingTechnician: 7,
  refurbisher: 8, //MATERIAL PRODUCER
  refurbisherUser: 9,
  trader: 10, //TRADING COMPANY
  traderUser: 11,
  supplier: 12, //PART_PRODUCER
  supplierUser: 13,
  producer: 14, // Maker
  producerUser: 15,
  thirdPartyRecycle: 16, //THIRD_PARTY_RECYCLER
  thirdPartyRecycleUser: 17,
  disposer: 18,
  disposerUser: 19,
  secondHandBuyer: 20, //SECOND_HAND_BUYER
  secondHandBuyerUser: 21,
  transporter: 22,
  nationalGov: 23,
  nationalGovUser: 24,
  cpcbGov: 25,
  cpcbGovUser: 26,
  spcbGov: 27,
  spcbGovUser: 28,
  districtGov: 29,
  districtGovUser: 30,
  site: 'site',
  superUser: 37,
  dataEntry: 38,
  accounts: 33,
  finance: 34,
  collectionCenter: 35,
  processer: 'processer', //temporary role
  scrappingFacilityManager: 36,
  categoryUser: 39,
  salesUser: 40,
  operationsUser: 41,
  scrappingFacilityEntryUser: 42,
  procurement: 43,
  operations: 44,
  sales: 45,
  pcrSupplier: 46,
  generator: 47,
}

const {
  consumerUser,
  dealerUser,
  recyclingTechnician,
  refurbisherUser,
  traderUser,
  supplierUser,
  producerUser,
  thirdPartyRecycleUser,
  disposerUser,
  secondHandBuyerUser,
  nationalGovUser,
  cpcbGovUser,
  spcbGovUser,
  districtGovUser,
  superUser,
  dataEntry,
  finance,
  categoryUser,
  salesUser,
  operationsUser,
  scrappingFacilityEntryUser,
} = userWiseRole

const childUsers = [
  consumerUser,
  dealerUser,
  recyclingTechnician,
  refurbisherUser,
  traderUser,
  supplierUser,
  producerUser,
  thirdPartyRecycleUser,
  disposerUser,
  secondHandBuyerUser,
  nationalGovUser,
  cpcbGovUser,
  spcbGovUser,
  districtGovUser,
  superUser,
  dataEntry,
  finance,
  categoryUser,
  salesUser,
  operationsUser,
  scrappingFacilityEntryUser,
]

const userDataList = ({ roleId }) => {
  return { list: [] }
}

const getDummyUser = ({ roleId, userId }) => {
  const userList = userDataList({ roleId })?.list
  return userList?.find(user => isEqual(user?.id, userId)) || userList?.[0]
}

const MAX_FILE_SIZE = 1024 * 1024 * 5 //5MB

const VSSL_USER_ID = 6014

/** FG Entry Details / income-material label overrides (home + jobs) for this user id. */
const INCOME_MATERIAL_DETAILS_USER_ID = 6008
export const DISPATCH_INVOICE_USER_ID = [5246, 56]

export {
  childUsers,
  getDummyUser,
  MAX_FILE_SIZE,
  userDataList,
  userWiseRole,
  VSSL_USER_ID,
  INCOME_MATERIAL_DETAILS_USER_ID,
}
